export const FORM_ERROR_HEADING = 'Something Went Wrong';
export const FORM_ERROR_BODY =
  'Sorry, we were unable to process your request. Please try again or come back later.';
export const FORM_ERROR_CTA_LABEL = 'OK';
